import { isReading } from "./plc-bench-reading";

export async function readPlcBench() {
      const response = await fetch("/api/demo/plc-bench/status", { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) throw new Error(response.status === 404 ? "Bu ekran yalnız yerel demo yöneticisine açık." : "PLC okuması alınamadı.");
      const payload: unknown = await response.json();
      if (!isReading(payload)) throw new Error("PLC yanıtı geçersiz.");
return payload;
}
